import { useLocalReactionStore } from "designSystem/hooks";
import { URL_HIGG } from "csi/reflection/reflectionConstants";
import { resolveNode } from "csi/service/nodeService";
import WorkingCache from "csi/state/WorkingCache";
import React, { FunctionComponent } from "react";
import { HiggSetupStore, HiggSetupStoreContext } from "./HiggSetupStore";
import { SetupHigg } from "./SetupHigg";

const ConnectToHigg: FunctionComponent = () => {
	const higgSetupStore = useLocalReactionStore(async () => {
		const cache = new WorkingCache();
		await resolveNode(URL_HIGG, cache);
		return new HiggSetupStore(cache);
	});

	return (
		<HiggSetupStoreContext.Provider value={higgSetupStore}>
			{higgSetupStore &&
				<SetupHigg />
			}
		</HiggSetupStoreContext.Provider>
	);
};

export default ConnectToHigg;
